import * as Yup from 'yup';

import { formatNumberToCurrencyString } from '@utils';
import { translate } from '@utils';

export const getValidationSchema = () => {
  return Yup.number().when('employmentStatus', {
    is: 'UNEMPLOYED',
    then: (value) =>
      value
        .typeError(
          translate('subModules/householdIncome:validation.validDollarAmount')
        )
        .required(translate('subModules/householdIncome:validation.required'))
        .min(
          0,
          translate('subModules/householdIncome:validation.validDollarAmount')
        ),
    otherwise: (value) =>
      value
        .typeError(
          translate('subModules/householdIncome:validation.validDollarAmount')
        )
        .positive(
          translate('subModules/householdIncome:validation.validDollarAmount')
        )
        .max(
          2000000,
          translate(
            'subModules/householdIncome:validation.validMaxDollarAmount',
            {
              amount: formatNumberToCurrencyString(2000000),
            }
          )
        )
        .required(translate('subModules/householdIncome:validation.required')),
  });
};
